import { mapDataSource, RawDataSource } from '~/Api/DataSource';
import Price from '~/utils/Price';

import ReferencedProduct from './ReferencedProduct';

export interface RawReferencedProduct {
	id: string;
	currentMaximumWholesalePrice: Price | null;
	dataSource: RawDataSource;
}

export default function mapReferencedProduct(product: RawReferencedProduct): ReferencedProduct {
	return new ReferencedProduct(
		product.id,
		product.currentMaximumWholesalePrice !== null
			? new Price(product.currentMaximumWholesalePrice.value, product.currentMaximumWholesalePrice.currency)
			: null,
		mapDataSource(product.dataSource)
	);
}
